import React, { Component } from 'react'
import Icons from '~/Common-Objects/UI/Icons/index'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'

const corners = [
    { name: 'borderRadiusTopLeft', title: 'Top Left', icon: 'borderRadiusTopLeft' },
    { name: 'borderRadiusTopRight', title: 'Top Right', icon: 'borderRadiusTopRight' },
    { name: 'borderRadiusBottomLeft', title: 'Bottom Left', icon: 'borderRadiusBottomLeft' },
    { name: 'borderRadiusBottomRight', title: 'Bottom Right', icon: 'borderRadiusBottomRight' }
]

export default class BorderRadiusHolder extends Component {
    constructor(props) {
        super(props)
        this.state = {
            expanded: false,
            borderRadiusTopLeft: 0,
            borderRadiusTopRight: 0,
            borderRadiusBottomLeft: 0,
            borderRadiusBottomRight: 0,
            disabled: false,
            showToggle: true
        }

        this.changeValue = this.changeValue.bind(this)
        this.toggleExpanded = this.toggleExpanded.bind(this)
        this.findMember = this.findMember.bind(this)
    }

    componentDidMount() {
        let values = {}
        let showToggle = true

        corners.forEach((corner) => {
            const member = this.findMember(corner.title)
            values[corner.name] = String(member?.props.value || '0').replace('px', '')
            if (member?.props.elementData.showToggle === false) showToggle = false
        })

        // expanded renders the single "all corners" input, so only collapse when every corner already matches
        let expanded = corners.every((corner) => values[corner.name] === values[corners[0].name])

        this.setState({ ...values, expanded, showToggle })
    }

    findMember(title) {
        return this.props?.clusterMembers?.find((c) => c?.props.title == title)
    }

    async changeValue(name, value) {
        let finalValue = value
        const isValidValue = value && !isNaN(value)
        if (isValidValue) {
            finalValue = value + 'px'
        }

        if (name === 'all') {
            let values = {}
            corners.forEach((corner) => (values[corner.name] = value))
            this.setState(values)

            if (isValidValue) {
                const members = corners.map((corner) => this.findMember(corner.title))
                if (members.every((member) => member)) {
                    await this.props.updateVal(
                        members.map((member) => member.props.path),
                        finalValue
                    )
                }
            }
            return
        }

        const corner = corners.find((c) => c.name === name)
        if (!corner) return

        this.setState({ [corner.name]: value })

        if (isValidValue) {
            const member = this.findMember(corner.title)
            if (member) {
                await this.props.updateVal(member.props.path, finalValue)
            }
        }
    }

    async toggleExpanded() {
        if (!this.state.expanded) {
            this.setState({ disabled: true })
            await this.changeValue('all', this.state.borderRadiusTopLeft)
            this.setState({ disabled: false })
        }
        this.setState({ expanded: !this.state.expanded })
    }

    renderCorner(corner) {
        return (
            <TextInput
                key={corner.name}
                disabled={this.state.disabled}
                iconLeft={<Icons color={'#4B4B4B'} icon={corner.icon} />}
                value={this.state[corner.name]}
                name={corner.name}
                onChange={(e) => this.changeValue(corner.name, e.target.value)}
            />
        )
    }

    render() {
        if (this.state.expanded) {
            return (
                <div className='dndEditorv2-dd_toolHolder dndEditorv2-margin-padding-holder'>
                    <span className='dndEditorv2-margin-padding-holder-label'>Border Radius</span>
                    <div className='dd_inputTool dndEditorv2-margin-padding-holder-InputsHolder'>
                        <TextInput
                            disabled={this.state.disabled}
                            value={this.state.borderRadiusTopLeft}
                            iconLeft={<Icons color={'#4B4B4B'} icon='borderRadiusAll' />}
                            name='all'
                            onChange={(e) => this.changeValue('all', e.target.value)}
                        />
                        {this.state.showToggle && (
                            <div className='dndEditorv2-margin-padding-holder-InputsHolder-Expander'>
                                <Icons color={'#4B4B4B'} icon='paddingExpander' onClick={this.toggleExpanded} />
                            </div>
                        )}
                    </div>
                </div>
            )
        }

        return (
            <div className='dndEditorv2-dd_toolHolder dndEditorv2-margin-padding-holder'>
                <span className='dndEditorv2-margin-padding-holder-label'>Border Radius</span>
                <div className='dd_inputTool dndEditorv2-margin-padding-holder-expandedInputsHolder'>
                    <div className='dndEditorv2-margin-padding-holder-expandedInputsHolder-inner'>
                        <div className='dndEditorv2-margin-padding-holder-expandedInputsHolder-inner-row'>
                            {corners.slice(0, 2).map((corner) => this.renderCorner(corner))}
                        </div>
                        <div className='dndEditorv2-margin-padding-holder-expandedInputsHolder-inner-row'>
                            {corners.slice(2).map((corner) => this.renderCorner(corner))}
                        </div>
                    </div>
                    {this.state.showToggle && (
                        <div className='dndEditorv2-margin-padding-holder-expandedInputsHolder-Expander'>
                            <Icons
                                color={'#4B4B4B'}
                                icon='paddingExpander'
                                onClick={this.toggleExpanded}
                                outerStyle={{ height: 17 }}
                            />
                        </div>
                    )}
                </div>
            </div>
        )
    }
}
